import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  MenuIcon,
  styled,
  Text,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { MENU_DRAWER_WIDTH_LARGE } from '../../constants';
import { useSidebar } from '../../providers';
import { NavMenuItem, NestedMenuItem } from '../menu-item';
import { SidebarLogo, SidebarStickyMenu } from '../sidebar';

export const Sidebar = styled(Drawer, {
  name: 'Sidebar',
  slot: 'Root',
  overridesResolver: (props, styles) => [styles['root']],
})(({ theme }) => ({
  display: 'block',

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
  '.MuiPaper-root': {
    width: MENU_DRAWER_WIDTH_LARGE,
  },
}));

function HamburgerMenu() {
  const { appMenu } = useSidebar();
  const [isOpen, { open, close }] = useDisclosure(false);

  return (
    <>
      <IconButton
        color='inherit'
        aria-label='open drawer'
        edge='start'
        onClick={open}
        sx={{ display: { md: 'none' } }}
      >
        <MenuIcon />
      </IconButton>
      <Sidebar
        variant='temporary'
        open={isOpen}
        onClose={close}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <SidebarLogo />
        <List>
          {appMenu.map((menu) => (
            <div key={menu.section}>
              <ListItemButton disabled className='section'>
                <Text variant='body1'>{menu.section}</Text>
              </ListItemButton>
              {menu.items?.map((item) =>
                item.subMenu ? (
                  <NestedMenuItem key={item.label as string} {...item} />
                ) : (
                  <NavMenuItem key={item.label as string} {...item} />
                ),
              )}
            </div>
          ))}
        </List>
        <SidebarStickyMenu hideToggleButton />
      </Sidebar>
    </>
  );
}

export default HamburgerMenu;
